import { Flex, Typography } from "antd";
import styles from "./footer.module.css";
import { Link } from "react-router-dom";
import { routes } from "constants/routes";
import { useStores } from "stores";
import { observer } from "mobx-react";

export const Footer = observer(() => {
  const { webSettings } = useStores();
  const { email, phoneNumbers, copyrightText } = webSettings.settings.data;

  return (
    <Flex className={styles.footer}>
      <Flex gap="36px">
        {email && (
          <Flex className={styles.contactsItem}>
            <Typography.Text className="text-middle">Поддержка:</Typography.Text>
            <Typography.Text className={`text-middle ${styles.emailLink}`} underline>
              <Link to={`mailto:${email}`}>{email}</Link>
            </Typography.Text>
          </Flex>
        )}
        {/* {CONTACTS_MAIL_CLIENT && (
          <Flex className={styles.contactsItem}>
            <Typography.Text className="text-middle">
              Клиентская поддержка:
            </Typography.Text>
            <Typography.Text className="text-middle">{CONTACTS_MAIL_CLIENT}</Typography.Text>
          </Flex>
        )} */}
        {phoneNumbers.length > 0 && (
          <Flex className={styles.contactsItem}>
            {/* <Typography.Text className="text-middle">
              Телефон:
            </Typography.Text> */}
            <Typography.Text className="text-middle">{phoneNumbers[0]}</Typography.Text>
          </Flex>
        )}
      </Flex>

      <Flex gap="36px" align="center">
        <Flex className={styles.contactsItem}>
          <Link to={`/${routes.info}`}>
            <Typography.Text className="text-middle">Информация</Typography.Text>
          </Link>
        </Flex>
        <Flex className={styles.contactsItem}>
          <Typography.Text className="text-middle">{copyrightText}</Typography.Text>
        </Flex>
      </Flex>
    </Flex>
  );
});
